import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const NMPAConsulting = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'EU MDR/FDA/NMPA Consulting', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="EU MDR/FDA/NMPA Consulting" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section class="service-details section-space">
    <div class="container">
        <div class="row flex-xl-row flex-column-reverse">
            <div class="col-xl-4">
                <div class="sidebar sidebar-rr-sticky">
                    <div class="sidebar__widget-service mb-30">
                        <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                        <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                        <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
                        <Link to="/regulatory-consulting">EU MDR/FDA/NMPA Consulting <i class="fa-solid fa-plus"></i> </Link>
                    </div>

                    <div class="sidebar__widget-contact__service text-center">
                        <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us?</h4>
                        <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i> (+86) 19811976744</a></p>
                        <Link to="/contact-us#" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="service-details__content">
                    <div class="service-details__content-media mb-20">
                        <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                    </div>

                    <h2 class="title-animation mb-20">EU MDR/FDA/NMPA Consulting</h2>

                    <p class="mb-20">
                        EU MDR/FDA/NMPA Consulting is a specialized service offering expert guidance to companies and institutions engaged in medical product development, manufacturing, and commercialization. Our consulting services assist in navigating complex regulatory, clinical, and quality requirements to ensure that medical products are safe, effective, and globally compliant.
                    </p>

                    <h3 class="title-animation mb-10">Who Benefits from Our Consulting?</h3>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span> Startups: Guidance on regulatory approvals and market entry.</li>
                        <li><span><i class="fa-solid fa-check"></i></span> Established Companies: Compliance maintenance and market expansion.</li>
                        <li><span><i class="fa-solid fa-check"></i></span> Healthcare Providers & Hospitals: Ensuring new devices meet clinical and operational needs.</li>
                        <li><span><i class="fa-solid fa-check"></i></span> Investors & Stakeholders: Insights into regulatory landscapes for informed decisions.</li>
                    </ul>

                    <h3 class="title-animation mb-10">Our Services in EU MDR/FDA/NMPA Consulting</h3>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Regulatory Compliance Consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Quality Management Systems (QMS) Consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Clinical Research Consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Product Development Consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Risk Management Consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Market Access & Reimbursement Consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Post-Market Surveillance Consulting</h5></li>
                    </ul>

                    <h3 class="title-animation mb-10">How We Support You</h3>
                    <p class="mb-30">SQUARE MEDTECH’s multidisciplinary team of clinical specialists and engineering professionals offers one-stop consultancy for medical product research & development.</p>

                    <div class="row">
                        <div class="col-lg-7">
                            <div class="service-details__content-media-item service-details__content-media-item-1">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Risk Management and Compliance</h4>
                                <p>We offer tailored strategies to mitigate risks, ensuring compliance with product classification standards and minimizing regulatory hurdles.</p>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="service-details__content-media-item service-details__content-media-item-2">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Market Entry & Compliance</h4>
                                <p>We help businesses navigate global regulatory landscapes, ensuring smooth market entry while maintaining strict compliance with international standards.</p>
                            </div>
                        </div>
                    </div>

                    <h3 class="title-animation mb-10">Technical Documentation & Post-Market Surveillance</h3>
                    <p class="mb-30">Our team provides comprehensive support in preparing technical documents for new and existing medical products. We also guide post-market surveillance strategies, including data collection, bias minimization, and regulatory submissions.</p>
                </div>
            </div>
        </div>
    </div>
</section>

       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Solutions for Healthcare Providers</h4>
                    <ul class="color-white mb-0">
                        <li>Consultancy for Healthcare Startups</li>
                        <li>Consultation for Hospitals and Clinics</li>
                        <li>Consultation for Pharma & Biotech Industries</li>
                    </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Service for Healthcare Providers</h4>
                      <ul class="color-white mb-0">
                        <li>Clinical Research Consultancy</li>
                        <li>Global & Local Regulatory Consultancy</li>
                        <li>Data Management Guidance Consultancy</li>
                      </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
